import type { IconData } from '@stacksjs/iconify-core'

export const mf1x1: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h512v512H0z\"/><path fill=\"#000091\" d=\"M0 0h170.7v512H0z\"/><path fill=\"#e1000f\" d=\"M341.3 0H512v512H341.3z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mf1x1
